import declare from "dojo/_base/declare";
import Table from "csi/table/Widget";
import locale from "csi/locale";

const CNCTable = declare(Table, {
	_getNoResultDescription: (hasColumnFilter, hasNewAction) => {
		return locale.resource("CareAndCompTablePlaceholder");
	},
});

export = CNCTable;
